import { logos } from './Logos';

import PortraitPhoto from './portrait.jpg';
import Oblador from './Oblador.webp';

export const Portrait = PortraitPhoto;
export const ObladorMap = Oblador;

export const techLogos = logos;

export * as DemoReels from './DemoReels'